import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/admin/Sidebar";
import Topbar from "../components/admin/Topbar";
import Footer from "../components/admin/Footer";
import "./AdminLayouts.css";

const AdminLayout = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  }, []);

  return (
    <div className="admin-wrapper">
     <Sidebar 
  isOpen={isOpen} 
  closeSidebar={() => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  }} 
/>


      <div className={`admin-main ${isOpen ? "expanded" : "collapsed"}`}>
        <Topbar toggleSidebar={toggleSidebar} />

        <div className="admin-content">
          <Outlet />
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default AdminLayout;
